export class DictionaryCountry {
    russian: string;
    latin: string;
    full: string;
}

export class DictionaryFederalSubject {
    code: string;
    name: string;
}

export class AddressDictionary {
    public static subjects: DictionaryFederalSubject[] = [
        { code: '01', name: 'РЕСПУБЛИКА АДЫГЕЯ' },
        { code: '02', name: 'РЕСПУБЛИКА БАШКОРТОСТАН' },
        { code: '03', name: 'РЕСПУБЛИКА БУРЯТИЯ' },
        { code: '04', name: 'РЕСПУБЛИКА АЛТАЙ' },
        { code: '05', name: 'РЕСПУБЛИКА ДАГЕСТАН' },
        { code: '06', name: 'РЕСПУБЛИКА ИНГУШЕТИЯ' },
        { code: '07', name: 'КАБАРДИНО-БАЛКАРСКАЯ РЕСПУБЛИКА' },
        { code: '08', name: 'РЕСПУБЛИКА КАЛМЫКИЯ' },
        { code: '09', name: 'КАРАЧАЕВО-ЧЕРКЕССКАЯ РЕСПУБЛИКА' },
        { code: '10', name: 'РЕСПУБЛИКА КАРЕЛИЯ' },
        { code: '11', name: 'РЕСПУБЛИКА КОМИ' },
        { code: '12', name: 'РЕСПУБЛИКА МАРИЙ ЭЛ' },
        { code: '13', name: 'РЕСПУБЛИКА МОРДОВИЯ' },
        { code: '14', name: 'РЕСПУБЛИКА САХА (ЯКУТИЯ)' },
        { code: '15', name: 'РЕСПУБЛИКА СЕВЕРНАЯ ОСЕТИЯ — АЛАНИЯ' },
        { code: '16', name: 'РЕСПУБЛИКА ТАТАРСТАН' },
        { code: '17', name: 'РЕСПУБЛИКА ТЫВА' },
        { code: '18', name: 'УДМУРТСКАЯ РЕСПУБЛИКА' },
        { code: '19', name: 'РЕСПУБЛИКА ХАКАСИЯ' },
        { code: '20', name: 'ЧЕЧЕНСКАЯ РЕСПУБЛИКА' },
        { code: '21', name: 'ЧУВАШСКАЯ РЕСПУБЛИКА' },
        { code: '22', name: 'АЛТАЙСКИЙ КРАЙ' },
        { code: '23', name: 'КРАСНОДАРСКИЙ КРАЙ' },
        { code: '24', name: 'КРАСНОЯРСКИЙ КРАЙ' },
        { code: '25', name: 'ПРИМОРСКИЙ КРАЙ' },
        { code: '26', name: 'СТАВРОПОЛЬСКИЙ КРАЙ' },
        { code: '27', name: 'ХАБАРОВСКИЙ КРАЙ' },
        { code: '28', name: 'АМУРСКАЯ ОБЛАСТЬ' },
        { code: '29', name: 'АРХАНГЕЛЬСКАЯ ОБЛАСТЬ' },
        { code: '30', name: 'АСТРАХАНСКАЯ ОБЛАСТЬ' },
        { code: '31', name: 'БЕЛГОРОДСКАЯ ОБЛАСТЬ' },
        { code: '32', name: 'БРЯНСКАЯ ОБЛАСТЬ' },
        { code: '33', name: 'ВЛАДИМИРСКАЯ ОБЛАСТЬ' },
        { code: '34', name: 'ВОЛГОГРАДСКАЯ ОБЛАСТЬ' },
        { code: '35', name: 'ВОЛОГОДСКАЯ ОБЛАСТЬ' },
        { code: '36', name: 'ВОРОНЕЖСКАЯ ОБЛАСТЬ' },
        { code: '37', name: 'ИВАНОВСКАЯ ОБЛАСТЬ' },
        { code: '38', name: 'ИРКУТСКАЯ ОБЛАСТЬ' },
        { code: '39', name: 'КАЛИНИНГРАДСКАЯ ОБЛАСТЬ' },
        { code: '40', name: 'КАЛУЖСКАЯ ОБЛАСТЬ' },
        { code: '41', name: 'КАМЧАТСКИЙ КРАЙ' },
        { code: '42', name: 'КЕМЕРОВСКАЯ ОБЛАСТЬ' },
        { code: '43', name: 'КИРОВСКАЯ ОБЛАСТЬ' },
        { code: '44', name: 'КОСТРОМСКАЯ ОБЛАСТЬ' },
        { code: '45', name: 'КУРГАНСКАЯ ОБЛАСТЬ' },
        { code: '46', name: 'КУРСКАЯ ОБЛАСТЬ' },
        { code: '47', name: 'ЛЕНИНГРАДСКАЯ ОБЛАСТЬ' },
        { code: '48', name: 'ЛИПЕЦКАЯ ОБЛАСТЬ' },
        { code: '49', name: 'МАГАДАНСКАЯ ОБЛАСТЬ' },
        { code: '50', name: 'МОСКОВСКАЯ ОБЛАСТЬ' },
        { code: '51', name: 'МУРМАНСКАЯ ОБЛАСТЬ' },
        { code: '52', name: 'НИЖЕГОРОДСКАЯ ОБЛАСТЬ' },
        { code: '53', name: 'НОВГОРОДСКАЯ ОБЛАСТЬ' },
        { code: '54', name: 'НОВОСИБИРСКАЯ ОБЛАСТЬ' },
        { code: '55', name: 'ОМСКАЯ ОБЛАСТЬ' },
        { code: '56', name: 'ОРЕНБУРГСКАЯ ОБЛАСТЬ' },
        { code: '57', name: 'ОРЛОВСКАЯ ОБЛАСТЬ' },
        { code: '58', name: 'ПЕНЗЕНСКАЯ ОБЛАСТЬ' },
        { code: '59', name: 'ПЕРМСКИЙ КРАЙ' },
        { code: '60', name: 'ПСКОВСКАЯ ОБЛАСТЬ' },
        { code: '61', name: 'РОСТОВСКАЯ ОБЛАСТЬ' },
        { code: '62', name: 'РЯЗАНСКАЯ ОБЛАСТЬ' },
        { code: '63', name: 'САМАРСКАЯ ОБЛАСТЬ' },
        { code: '64', name: 'САРАТОВСКАЯ ОБЛАСТЬ' },
        { code: '65', name: 'САХАЛИНСКАЯ ОБЛАСТЬ' },
        { code: '66', name: 'СВЕРДЛОВСКАЯ ОБЛАСТЬ' },
        { code: '67', name: 'СМОЛЕНСКАЯ ОБЛАСТЬ' },
        { code: '68', name: 'ТАМБОВСКАЯ ОБЛАСТЬ' },
        { code: '69', name: 'ТВЕРСКАЯ ОБЛАСТЬ' },
        { code: '70', name: 'ТОМСКАЯ ОБЛАСТЬ' },
        { code: '71', name: 'ТУЛЬСКАЯ ОБЛАСТЬ' },
        { code: '72', name: 'ТЮМЕНСКАЯ ОБЛАСТЬ' },
        { code: '73', name: 'УЛЬЯНОВСКАЯ ОБЛАСТЬ' },
        { code: '74', name: 'ЧЕЛЯБИНСКАЯ ОБЛАСТЬ' },
        { code: '75', name: 'ЗАБАЙКАЛЬСКИЙ КРАЙ' },
        { code: '76', name: 'ЯРОСЛАВСКАЯ ОБЛАСТЬ' },
        { code: '77', name: 'МОСКВА' },
        { code: '78', name: 'САНКТ-ПЕТЕРБУРГ' },
        { code: '79', name: 'ЕВРЕЙСКАЯ АВТОНОМНАЯ ОБЛАСТЬ' },
        { code: '83', name: 'НЕНЕЦКИЙ АВТОНОМНЫЙ ОКРУГ' },
        { code: '86', name: 'ХАНТЫ-МАНСИЙСКИЙ АВТОНОМНЫЙ ОКРУГ - ЮГРА' },
        { code: '87', name: 'ЧУКОТСКИЙ АВТОНОМНЫЙ ОКРУГ' },
        { code: '89', name: 'ЯМАЛО-НЕНЕЦКИЙ АВТОНОМНЫЙ ОКРУГ' },
        { code: '91', name: 'РЕСПУБЛИКА КРЫМ' },
        { code: '92', name: 'СЕВАСТОПОЛЬ' }
    ]
}
